const translations = {
  "en": {
    "Coming soon, please choose other ways": "Coming soon, please choose other ways"
  },
  "zh-tw": {
    "Coming soon, please choose other ways": "即將推出，請選擇其他方式"
  }
};

export default translations;
